import { dbFieldTypeMap } from '@databases/collab/convert/to-collab';
import { type MutableDatabase } from '@databases/model/database';
import { type FieldType } from '@databases/model/field';
// FIX ME circular dependency
// eslint-disable-next-line workspaces/require-dependency
import { type DatabaseChangeType } from '@databases/types/redux';

import {
  isNumericFieldType,
  nonNumericCollabCalculationTypes
} from '../../../../database/collab-calculation-helpers.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const setFieldType: YJSChangeHandler<DatabaseChangeType.SET_FIELD_TYPE> = ({
  ydb,
  change
}) => {
  function runCalculations(db: MutableDatabase, destType: FieldType) {
    return function calculate(viewId: string) {
      const collabCalculationType = db.viewsById[viewId].calculations[change.fieldId];

      // If the destination type is numeric, we can keep the calculation.
      // This is because the non-numeric calculations are a subset of the
      // numeric calculations. If the destination type is non-numeric, we
      // need to check if the calculation is a non-numeric calculation. If
      // it isn't, we will remove it.
      if (
        collabCalculationType &&
        !isNumericFieldType(destType) &&
        !nonNumericCollabCalculationTypes.includes(collabCalculationType)
      ) {
        db.viewsById[viewId].removeCalculation(change.fieldId);
      }
    };
  }

  ydb.mutate((db) => {
    const destType = dbFieldTypeMap[change.fieldType];

    if (!destType) {
      throw new Error('unsupported field type ' + change.fieldType);
    }

    db.fieldsById[change.fieldId].type = destType;

    db.views.forEach(runCalculations(db, destType));
  });
};
